import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=e0207c1e&scoped=true"
import script from "./dashboard.vue?vue&type=script&lang=ts"
export * from "./dashboard.vue?vue&type=script&lang=ts"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=e0207c1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0207c1e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainSidebar: require('/app/components/Layout/Sidebar/MainSidebar.vue').default,LoggedOutSidebar: require('/app/components/Layout/LoggedOutSidebar.vue').default,MobileNav: require('/app/components/Layout/MobileNav.vue').default,GroupHeader: require('/app/components/Layout/GroupHeader.vue').default,DashboardLayoutHeader: require('/app/components/Common/UI2/DashboardLayoutHeader.vue').default})
